// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { Block } from './Block'
import { BlockFromJSON, BlockFromJSONTyped, BlockToJSON } from './Block'

/**
 *
 * @export
 * @interface Activity
 */
export interface Activity {
  /**
   *
   * @type {string}
   * @memberof Activity
   */
  activityId: string
  /**
   *
   * @type {string}
   * @memberof Activity
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof Activity
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof Activity
   */
  thumbnail?: string | null
  /**
   *
   * @type {string}
   * @memberof Activity
   */
  template?: string | null
  /**
   *
   * @type {Array<Block>}
   * @memberof Activity
   */
  blocks?: Array<Block> | null
}

/**
 * Check if a given object implements the Activity interface.
 */
export function instanceOfActivity(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'activityId' in value

  return isInstance
}

export function ActivityFromJSON(json: any): Activity {
  return ActivityFromJSONTyped(json, false)
}

export function ActivityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Activity {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityId: json['activity_id'],
    title: !exists(json, 'title') ? undefined : json['title'],
    description: !exists(json, 'description') ? undefined : json['description'],
    thumbnail: !exists(json, 'thumbnail') ? undefined : json['thumbnail'],
    template: !exists(json, 'template') ? undefined : json['template'],
    blocks: !exists(json, 'blocks')
      ? undefined
      : json['blocks'] === null
        ? null
        : (json['blocks'] as Array<any>).map(BlockFromJSON),
  }
}

export function ActivityToJSON(value?: Activity | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activity_id: value.activityId,
    title: value.title,
    description: value.description,
    thumbnail: value.thumbnail,
    template: value.template,
    blocks:
      value.blocks === undefined
        ? undefined
        : value.blocks === null
          ? null
          : (value.blocks as Array<any>).map(BlockToJSON),
  }
}
